<div class="container mb-5 marginMobile">
        <div class="row">
          <div class="col-12 col-md-4 col-lg-4 col-xl-2">
            <app-dashmenu></app-dashmenu>
          </div>
          <div class="col-12 col-md-8 col-lg-8 col-xl-10">
            <div class="card p-2">
                  <canvas #balance class="mb-5" height="500"></canvas>
                  <div class="container">
                    <div class="row">
                      <div class="col-sm-12 mt-5">
                        <div class="table-responsive">
                          <table id="tableBalance" class="table table-striped" style="width:100%">
                            <thead>
                              <tr>
                                  <th>Date comptable</th>
                                  <th>Montant</th>
                                  <th>Numéro chèque /effet</th>
                                  <th>Libelle</th>
                                  <th>Date d’échéance </th>
                                  <th>Type de Piece chèque ou effet</th>
                              </tr>
                          </thead>
                            <tbody>
                                <tr *ngFor="let data of dataPortfeuille" >
                                    <td>{{data.ACCDAT}}</td>
                                    <td>{{data.AMTCUR}}</td>
                                    <td>{{data.BPR}}</td>
                                    <td>{{data.CHQNUM}}</td>
                                    <td>{{data.DES}}</td>
                                    <td>{{data.DUDDAT}}</td>
                                    <td>{{data.STA}}</td>
                                </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
